import SEO from "../designSystem/SEO";
import PrimaryButtonSmall from "../designSystem/buttons/PrimaryButtonSmall";
import ResidentialMortgageImage from "../../assets/images/residential_mortgages_01.png";
import { ReactComponent as LendersIcon } from "../../assets/icons/capc_icons_90_uk_lenders.svg";
import { ReactComponent as PersonalIcon } from "../../assets/icons/capc_icons_personalised_advice.svg";
import { ReactComponent as ProfessionalIcon } from "../../assets/icons/capc_icons_end-to-end_support.svg";
import Hero from "../designSystem/Hero";

const highlights = [
  {
    title: "Personalised Advice",
    icon: PersonalIcon,
    text: "Tailored mortgage guidance for first-time buyers, home movers, remortgages and clients with more complex borrowing requirements.",
  },
  {
    title: "90+ UK Lenders",
    icon: LendersIcon,
    text: "Access to a wide panel of high street banks, specialist lenders and private banks to find the right mortgage for your needs.",
  },
  {
    title: "End-to-End Support",
    icon: ProfessionalIcon,
    text: "From your initial enquiry through to completion, we manage the paperwork, liaise with lenders and keep you informed every step of the way.",
  },
];

const ResidentialMortgagesPage = () => (
  <main>
    <SEO
      title="Residential Mortgage Services"
      description="Personal residential mortgage advice with access to a broad range of UK lenders."
      path="/residential-mortgages"
    />
    <Hero wantOverlay={false}>
      <div className="content-container">
        <div className="column gap-m align-center">
          <div className="nav-text text-secondary-1 uppercase">Our services</div>
          <h1 className="text-primary-1 text-center">Residential Mortgages</h1>
          <div className="content text-primary-2 text-center">
            A residential mortgage is a loan used to purchase a property that
            you intend to live in as your main home. Whether you're buying your
            first property, moving to a new home or purchasing your forever
            home, finding the right mortgage can make a significant difference
            to your monthly payments and long-term financial goals. With
            thousands of mortgage products available, choosing the right lender
            and deal can feel overwhelming. That's where CAPC can help.
          </div>
          <PrimaryButtonSmall text="contact us" />
        </div>
      </div>
    </Hero>

    <section className="background-container bg-white">
      <div className="content-container grid2 gap-xxxxxl grid-stretch">
        <img
          src={ResidentialMortgageImage}
          alt="Residential homes representing mortgage options for home buyers"
          className="hero-image"
        />
        <div className="column gap-l">
          <h3 className="text-primary-2">
            Why Choose CAPC for Residential Mortgages?
          </h3>{" "}
          <div className="column gap-m">
            <div className="content text-primary-2">
              Our experienced advisers take the time to understand your
              circumstances, income and future plans before recommending a
              mortgage that's right for you. We'll guide you through every stage
              of the process, handling the paperwork, liaising with lenders and
              keeping you informed throughout. Our aim is to make securing your
              mortgage as straightforward and stress-free as possible.
            </div>
            <div className="content text-primary-2">
              Whether you're a first-time buyer, home mover or looking for a
              more complex lending solution, CAPC is here to provide expert
              advice and ongoing support every step of the way.
            </div>
            <div className="body1 text-primary-2">
              *Your home may be repossessed if you do not keep up with
              repayments on your mortgage.
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="background-container bg-primary-2">
      <div className="content-container grid3 gap-xxxxl">
        {highlights.map(({ title, icon: Icon, text }) => (
          <article className="column gap-xl align-center" key={title}>
            <Icon aria-hidden="true" />
            <div className="column gap-m align-center">
              <div className="subtitle-semibold text-white text-center">
                {title}
              </div>
              <div className="content text-white text-center">{text}</div>
            </div>
          </article>
        ))}
      </div>
    </section>
  </main>
);

export default ResidentialMortgagesPage;
